// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"480f1df6","453":"9d7feb9f"}[chunkId] + ".chunk.js";
};